<p-multiselect
  class="cx-multi-select__control"
  [inputId]="inputId"
  [options]="options"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [group]="group"
  [optionGroupLabel]="optionGroupLabel ?? ''"
  [optionGroupChildren]="optionGroupChildren ?? ''"
  [appendTo]="appendTo"
  panelStyleClass="cx-multi-select-panel"
  [placeholder]="placeholder"
  [selectedItemsLabel]="selectedItemsLabel"
  [maxSelectedLabels]="maxSelectedLabels"
  [disabled]="isDisabled"
  [loading]="loading"
  [filter]="filter"
  [filterBy]="filterBy"
  [scrollHeight]="scrollHeight"
  [virtualScroll]="virtualScroll"
  [virtualScrollItemSize]="virtualScrollItemSize"
  [lazy]="lazy"
  [filterMatchMode]="filterMatchMode"
  [showHeader]="showPanelHeader"
  [showClear]="showClear"
  [invalid]="isInvalid"
  [dataKey]="optionValue"
  [ngModel]="multiValue"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onSelectionChange($event)"
  (onBlur)="onBlur()"
  (onFilter)="filterChange.emit($event.filter ?? '')"
  (onLazyLoad)="lazyLoad.emit($any($event))">
  @if (headerTemplate) {
    <ng-template pTemplate="header">
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    </ng-template>
  }
  @if (itemTemplate) {
    <ng-template pTemplate="item" let-option>
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: option }"></ng-container>
    </ng-template>
  }
  @if (selectedItemsTemplate) {
    <ng-template pTemplate="selecteditems" let-selectedOptions let-removeChip="removeChip">
      <ng-container
        *ngTemplateOutlet="selectedItemsTemplate; context: { $implicit: selectedOptions, removeChip: removeChip }"></ng-container>
    </ng-template>
  }
</p-multiselect>
